export default __webpack_public_path__ + "static/media/logo-filled.eda10c95.png";